import { OTP_EXAMPLE } from '../lib/env';

const OTP_REGEX = /^\d{6}$/;

export function isValidOtpFormat(code: string): boolean {
  return OTP_REGEX.test(code);
}

/**
 * Em modo demo, qualquer 6 dígitos válidos é aceito.
 * `OTP_EXAMPLE` (`000000`) é exibido como dica discreta no login.
 */
export function acceptOtp(code: string): boolean {
  return isValidOtpFormat(code);
}

export { OTP_EXAMPLE };
